import { Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { GateWayService } from '../../services/gateway-service.service';
import * as uuid from 'uuid';

@Component({
  selector: 'app-preload',
  templateUrl: './preload.component.html',
  styleUrls: ['./preload.component.scss']
})
export class PreloadComponent implements OnInit {
  public pid: any;
  public code: any;
  public state: any;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private gwService: GateWayService,
  ) {
    this.code = this.route.snapshot.queryParams["code"];
    this.state = localStorage.getItem('state');
  }

  async ngOnInit() {
    if (this.code) {
      await this.getGatewayToken(this.code);
      console.log("HAVE CODE")
    } else {
      console.log("DON'T HAVE CODE")
      this.router.navigate(["/error-page"], { queryParams: { state: this.state, errorCode: '02' } }).then(() => {
        localStorage.clear();
        window.location.reload();
      });

    }
  }

  async getGatewayToken(code) {
    localStorage.clear();

    await this.gwService.gatewayCallback(code).subscribe((success) => {
      console.log("success :", success)
      if (success.code == 200) {
        localStorage.setItem('access_token', success.data.access_token);
        localStorage.setItem('refresh_token', success.data.refresh_token);
        localStorage.setItem('username',success.data.userInfo.username)
        localStorage.setItem('display_name',success.data.userInfo.display_name)
        localStorage.setItem('system_role', success.data.userInfo.system_role);
        // localStorage.setItem('transactionid', uuid.v4());
        this.router.navigate(["/homepage"], { queryParams: { state: this.state } }).then(() => {
          window.location.reload();
        });
      } else {
        this.router.navigate(["/error-page"], { queryParams: { state: this.state, errorCode: '01' } }).then(() => {
          localStorage.clear();
          window.location.reload();
        });
      }
      (err) => {
        console.log("err :", err)
        this.router.navigate(["/error-page"], { queryParams: { state: this.state, errorCode: '01' } }).then(() => {
          localStorage.clear();
          window.location.reload();
        });
      }
    });
  }
}
